// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__17xEg","dragIcon":"SortableItem_dragIcon__2MGLD","disabled":"SortableItem_disabled__3PPIj"};